import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Space,
  Select,
  DatePicker,
  Table,
  Tooltip,
  Input,
  Col,
  Form,
  Popconfirm,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Archive } from "../../image/Archive.svg";

const VendorAssignRequestForQuotation = () => {
  const { t } = useTranslation();
  const columns = [
    {
      title: "SR NO",
      dataIndex: "SRno",
      key: "2",
    },
    {
      title: "RFQ NUMBER",
      dataIndex: "rfq_number",
      key: "3",
    },
    {
      title: "COMPANY NAME",
      dataIndex: "company_name",
      key: "4",
    },
    {
      title: "CATEGORY",
      dataIndex: "category",
      key: "5",
    },
    {
      title: "BUYER NAME",
      dataIndex: "buyer_name",
      key: "15",
    },
    {
      title: "RFQ DUE DATE",
      dataIndex: "approvaldate",
      key: "5",
    },
    {
      title: "ESTIMATED INQUIRY VALUE",
      dataIndex: "estimatedvalue",
      key: "15",
    },
    {
      title: "Assign to sales manager",
      width: "160px",
      dataIndex: "assigntobuyer",
      key: "6",
      render: (_, record) => (
        <Select
          // defaultValue={uomOptions.length > 0 ? uomOptions[0].value : ''}
          defaultValu=""
          style={{ width: 120 }}
        // onChange={(value) => handleUOMChange(value, record)}
        >
          {/* {uomOptions.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.unit_of_measurement}
          </Select.Option>
        ))} */}
        </Select>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: () => (
        <Space>
          <Tooltip title="View RFQ">
            <Link to="/vendor-request-for-quotation/Material-details">
              <EyeOutlined />
            </Link>
          </Tooltip>
          <Tooltip title="Download RFQ">
            <DownloadOutlined />
          </Tooltip>
          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
           // onConfirm={() => handleArchive(record.id)}
          >
            <Archive style={{ cursor: "pointer" }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const data = [
    {
      key: "1",
      SRno: "1",
      prcreator: "ABC",
      rfq_number: "00006",
      category: "cement",
      approvaldate: "24-08-23 15:15",
      estimatedvalue: "1,00,000",
      assigntobuyer: "Partially Placed",
      company_name: "RFQ Floated or Initiated",
      buyer_name: "abc",
    },
    {
      key: "2",
      SRno: "1",
      prcreator: "ABC",
      rfq_number: "00005",
      category: "cement",
      approvaldate: "24-08-23 15:15",
      estimatedvalue: "1,00,000",
      assigntobuyer: "Partially Placed",
      company_name: "RFQ yet to be Done",
      buyer_name: "abc",
    },
    {
      key: "3",
      SRno: "1",
      prcreator: "ABC",
      rfq_number: "00004",
      category: "cement",
      approvaldate: "24-08-23 15:15",
      estimatedvalue: "1,00,000",
      assigntobuyer: "Partially Placed",
      company_name: "Offer Received",
      buyer_name: "abc",
    },
  ];
  const { Search } = Input;



  // const handleArchive = async (id = "") => {
  //   // let ids = selectedRow;
  //   // if (ids.length === 0) {
  //   //   ids.push(id);
  //   // }
  //   // try {
  //   //   let apiResponse = await postRequest("category-tree-delete/", {
  //   //     deleted: ids,
  //   //   });
  //   //   if (apiResponse.data.success) {
  //   //     SuccessNotificationMsg(t("category_archive_successfully"));
  //   //     setReload(!reload);
  //   //     setSelectedRow([]);
  //   //   } else {
  //   //     ErrorNotificationMsg(t("error_in_delete_category"));
  //   //   }
  //   // } catch (error) {
  //   //   ErrorNotificationMsg(error);
  //   // }
  // };
  // const navigate ();
  const handleSelectChange = (name, value) => {
    //  setState({ ...state, [name]: value });
  };
  const handleDatepickerChange = (date, fieldName) => {
    if (date !== null) {
      // setState(prevState => {
      //   const newState = { ...prevState };
      //   newState[fieldName] = date;
      //   return newState;
      // });
    }
  };
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3> Assign Request For Quotation (RFQ) - Vendor </h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>RFQ</Breadcrumb.Item>
              <Breadcrumb.Item> Assign RFQ </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            <Link to="/vendor-request-for-quotation/assign/archive">
              <Archiveicon />
            </Link>
          </Space>
        </div>
      </div>
      <section className="grid-sec mt-5">
        <div className="PR-body">
          <div className="filterrow">
            <div className="filtercol">
              <Space wrap>

                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="unassignedpr"
                  // label="PO Order Placed"
                  //initialValue={state.maximum_income}
                  >
                    <Select
                      showArrow
                      showSearch
                      allowClear
                      placeholder="Unassigned RFQ"
                      //value={state.poorderplaced}
                      onChange={(value) =>
                        handleSelectChange("unassignedpr", value)
                      }
                      optionFilterProp="children"
                    >
                      <Select.Option value="Yes">Yes</Select.Option>
                      <Select.Option value="No">No</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="prstatus"
                  // label="PO Order Placed"
                  //initialValue={state.maximum_income}
                  >
                    <Select
                      showArrow
                      showSearch
                      allowClear
                      placeholder="RFQ Status"
                      //value={state.poorderplaced}
                      onChange={(value) =>
                        handleSelectChange("prstatus", value)
                      }
                      optionFilterProp="children"
                    >
                      <Select.Option value="Yes">Yes</Select.Option>
                      <Select.Option value="No">No</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="delivery-start-date"

                  //label="Delivery Start Date"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: <Trans>{t("val_delivery_date")}</Trans>,
                  //   },
                  // ]}
                  >
                    <DatePicker
                      className="custompiker"
                      format={"DD-MM-YYYY"}
                      placeholder="Select Start Date"
                      // value={date ? moment(date, 'DD-MM-YYYY') : null}
                      onChange={(value) =>
                        handleDatepickerChange("delivery-start-date", value)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="delivery-end-date"

                  //label="Delivery Start Date"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: <Trans>{t("val_delivery_date")}</Trans>,
                  //   },
                  // ]}
                  >
                    <DatePicker
                      className="custompiker"
                      format={"DD-MM-YYYY"}
                      placeholder="Select End Date"
                      // value={date ? moment(date, 'DD-MM-YYYY') : null}
                      onChange={(value) =>
                        handleDatepickerChange("delivery-end-date", value)
                      }
                    />
                  </Form.Item>
                </Col>
              </Space>
            </div>
            <div className="btnscol">
              <Space>
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Apply"
                  label="Apply"
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Apply"
                  label="Reset"
                />

                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Excel"
                  label="Excel"
                  icon={<img src={ExelDownload} alt="Plus Square" />}
                />
              </Space>
            </div>
          </div>
          <Table
            columns={columns}
            dataSource={data}
            rowSelection={rowSelection}
            scroll={{
              x: 1000,
            }}
          />
        </div>
      </section>
    </>
  );
};
export default VendorAssignRequestForQuotation;
